import { formatPrice } from '@/data/prices'
import { getApiUrl } from '@/config/api'

const state = () => ({
  items: [],
  loading: false,
  error: null
})

const mutations = {
  setItems(state, items) {
    state.items = items || []
  },
  setLoading(state, value) {
    state.loading = !!value
  },
  setError(state, error) {
    state.error = error || null
  }
}

const actions = {
  async fetchPrices({ state, commit }) {
    if (state.items.length) return

    commit('setLoading', true)
    commit('setError', null)
    try {
      const res = await fetch(getApiUrl('/api/prices'))
      if (!res.ok) throw new Error(`HTTP ${res.status}`)
      const data = await res.json()
      commit('setItems', data.prices || [])
    } catch (e) {
      console.error('Failed to load prices', e)
      commit('setError', e.message || 'Ошибка загрузки цен')
    } finally {
      commit('setLoading', false)
    }
  }
}

const getters = {
  priceRows: (state) => state.items,
  loading: (state) => state.loading,
  priceByKey: (state) => (key) => state.items.find((r) => r.sizeKey === key) || null,
  formattedPriceByKey: (state) => (key) => {
    const row = state.items.find((r) => r.sizeKey === key)
    return row ? formatPrice(row.price) : ''
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}

